// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import {
    MutationCreateContract2PlausibilitaetArgs,
    MutationDeleteContract2PlausibilitaetArgs,
} from '../../../mdqx-graphql-types';
import { Contract2PlausibilitaetEntity } from '../../../entities/mdqx/contract2plausibilitaet.entity';

export enum Contract2PlausibilitaetActionTypes {
    GetContract2PlausibilitaetenRequest = '[Contract2Plausibilitaeten] Get Request',
    GetContract2PlausibilitaetenResponse = '[Contract2Plausibilitaeten] Get Response',
    PostContract2PlausibilitaetRequest = '[Contract2Plausibilitaet] Post Request',
    PostContract2PlausibilitaetResponse = '[Contract2Plausibilitaet] Post Response',
    DeleteContract2PlausibilitaetRequest = '[Contract2Plausibilitaet] Delete Request',
    DeleteContract2PlausibilitaetResponse = '[Contract2Plausibilitaet] Delete Response',
}

export class GetContract2PlausibilitaetenRequest implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.GetContract2PlausibilitaetenRequest;
}

export class GetContract2PlausibilitaetenResponse implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.GetContract2PlausibilitaetenResponse;
    constructor(public Payload: Contract2PlausibilitaetEntity[]) {}
}

export class PostContract2PlausibilitaetRequest implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.PostContract2PlausibilitaetRequest;
    constructor(public Payload: MutationCreateContract2PlausibilitaetArgs) {}
}

export class PostContract2PlausibilitaetResponse implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.PostContract2PlausibilitaetResponse;
    constructor(public Payload: Contract2PlausibilitaetEntity) {}
}

export class DeleteContract2PlausibilitaetRequest implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.DeleteContract2PlausibilitaetRequest;
    constructor(public Payload: MutationDeleteContract2PlausibilitaetArgs) {}
}

export class DeleteContract2PlausibilitaetResponse implements Action {
    readonly type = Contract2PlausibilitaetActionTypes.DeleteContract2PlausibilitaetResponse;
    constructor(public Payload: number) {}
}

export type Contract2PlausibilitaetActions =
    | GetContract2PlausibilitaetenRequest
    | GetContract2PlausibilitaetenResponse
    | PostContract2PlausibilitaetRequest
    | PostContract2PlausibilitaetResponse
    | DeleteContract2PlausibilitaetRequest
    | DeleteContract2PlausibilitaetResponse;
